<template>
  <div>
    <!-- **************** TOP NAVBAR ****************************** -->
    <nav class="navbar navbar-expand-md pt-1 navbar-restyle">
      <div class="grain-effect"></div>
      <div class="container-fluid">
        <!-- Left side of Navbar -->
        <router-link v-if="!isLoggedIn" tag="div" to="/" exact>
          <a class=" ml-5 ">
            <img class="big-icon logo-icon" :src="require('@/assets/img/logo-oommur.svg')" alt="Logo icon"/> 
          </a>
        </router-link>
        <router-link v-else tag="div" to="/" exact>
          <a class=" ml-5 ">
            <img class="big-icon logo-icon" :src="require('@/assets/img/logo-oommur.svg')" alt="Logo icon"/> 
          </a>
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <!-- Right side of Navbar -->
        <div class="collapse navbar-collapse" id="navbarToggler">
          <ul class="nav navbar-nav navbar-right ml-auto ">
            <router-link v-if="isLoggedIn" v-on:click="resetMap" class="nav-menu-item" tag="li" to="/mapparams" exact>
              Mapa
            </router-link>
            <router-link v-if="isLoggedIn" class="nav-menu-item" tag="li" to="/upload" exact>
              Upload
            </router-link>
            <router-link v-if="isLoggedIn" class="nav-menu-item" tag="li" to="/va" exact>
              Entrenamiento VA
            </router-link>
            <!-- <router-link v-if="isLoggedIn" class="nav-menu-item" tag="li" to="#" exact>
              Download
            </router-link>
            <router-link v-if="isLoggedIn" class="nav-menu-item" tag="li" to="#" exact>
              Misiones
            </router-link> -->
            <li class="nav-item dropdown mr-5 nav-inicio">
              <a v-if="isLoggedIn" id="navbarDropdown" class=" dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <p class="d-inline-block nav-user">{{user}}</p>
              </a>
              <router-link  v-else-if="this.$route.name != 'Login'" tag="a" to="/login" exact>
                <a class="d-inline-block nav-user">Log in</a>
              </router-link>  
              <!-- User options pop up -->
              <div ref="dropdownuser" class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <div class="popup-body">
                  <div class="dropdown-item modal-call pointer" data-toggle="modal" data-target="#campaingsModal" > &nbsp;Campaings</div>
                  <div class="line-separator"><hr /></div>
                  <div  @click="logout" class="dropdown-item pointer">
                    &nbsp;Logout
                  </div>
                  <!-- <div class="dropdown-item modal-call"> &nbsp;<button @click="changeTheme">Cambiar tema</button></div> -->
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
        <configCampaigns></configCampaigns>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import configCampaigns from '@/components/configCampaigns'

export default {
  name: "oomurHeader",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isLoggedIn","user","theme"]),
    stations_or_density: {
      set (stat_or_den) { this.$store.dispatch('map_params/change_stations_or_density', stat_or_den); },
      get () { return this.$store.state.map_params.stations_or_density }
    },
    transect_status: {
        set (status) { this.$store.dispatch('map_params/change_transect_status', status); },
        get () { return this.$store.state.map_params.transect_status }
    },
  },
   components: {
    configCampaigns
  },
  mounted () {
  },
  watch: {
    $route(to, from) {
      if (from.name == 'MapParams'){
        if (this.stations_or_density[1] == 'density')
          this.$store.dispatch('map_params/change_stations_or_density', 'density')
        if (this.stations_or_density[2] == 'transect'){
          this.$store.dispatch('map_params/change_stations_or_density', 'transect')
          this.transect_status = 0
        }
      }
    }
  },
  methods: {
    logout: function () {
        this.$refs.dropdownuser.classList.remove('show')
        this.$store.dispatch('logout')
       .then(resp => { 
        console.log(resp)
       })
       .catch(err => err)
    },
    changeTheme: function () {
      var newTheme = ""
      if(this.theme == "normal") {
        newTheme = "dark"
      }
      else {
        newTheme = "normal"
      }
      this.$store.dispatch('changeTheme', {
        newTheme: newTheme
      });
    },
    resetMap: function(){
      console.log('sssss')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-restyle {
  background: rgb(72,115,157);
  background: linear-gradient(90deg, rgba(72,115,157,1) 0%, rgba(63,148,155,1) 50%, rgba(55,138,156,1) 100%);
  box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.3);
}
.nav-menu-item {
  color: white;
  cursor: pointer;
  margin-right: 30px;
}
.nav-menu-item:hover {
  color: #FFC200;
}
.navbar-nav {
  align-items: center;
}
.grain-effect {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  background-image: url('~@/assets/img/grain.png');
  z-index: -10;
  opacity: 0.3;
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue